export default {"src":"/_next/static/media/wallet.456306d4.svg","height":537,"width":478};